var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SubMenu',{staticClass:"account-nav-menu mt-3 mb-6 d-flex justify-content-center battle-submenu",attrs:{"items":_vm.routers,"variant":"horizontal"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_item = ref.item;
var name = ref_item.name;
var title = ref_item.title;
var routeName = ref_item.routeName;
return _c('router-link',{class:{ 'router-link-alias-active': _vm.isActiveLink(routeName) },attrs:{"active-class":"router-link-active-custom","to":{
      name: name,
      params: Object.assign({}, _vm.account.params,
        _vm.$route.params),
    }}},[_vm._v("\n    "+_vm._s(_vm.$t(("_web_account-tab_" + name), title))+"\n  ")])}}])})}
var staticRenderFns = []

export { render, staticRenderFns }